<template>
  <div>
    <div class="p-3 bg-white rounded-xl shadow-lg mx-4">
      <div class="grid grid-cols-2" @click="showFilters = !showFilters">
        <div class="flex items-center gap-4">
          <a-icon type="filter" class="text-lg ml-2"></a-icon>
          <h2 class="text-left text-lg text-gray-600">
            <b>Filtros de búsqueda</b>
          </h2>
        </div>
        <span
          class="h-5 w-5 m-2 flex justify-center items-center transition justify-self-end"
          :class="{ 'transform rotate-180': showFilters }"
        >
          <a-icon type="caret-down" class="text-xl my-auto" />
        </span>
      </div>
      <a-divider v-if="showFilters" class="mt-2 mb-2"></a-divider>
      <div
        class="flex gap-5 flex-wrap relative w-full border-box"
        v-show="showFilters"
      >
        <form id="filterSupportForm" @submit.prevent="submitForm">
          <div
            class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 relative"
          >
            <!-- Nombre completo del CF -->
            <BaseInput
              type="text"
              label="Nombre completo del CF"
              placeholder="Ej: Ander"
              v-model="form.name"
            />
            <!--Tipo de identificación -->
            <BaseSelect
              ref="tipo_documento"
              id="tipo_documento"
              label="Tipo de identificación"
              :selectOptions="formOptions.optionsIdentificationType"
              v-model="form.identification_type"
              :value="form.identification_type"
              :loading="loading"
            />
            <!--Número de identificación -->
            <BaseNumber
              label="Número de documento"
              placeholder="Ej: 123456789"
              v-model="form.identification_number"
              :doNotValidateNit="true"
            />
            <!--Correo electrónico -->
            <BaseInput
              type="email"
              label="Correo electrónico"
              placeholder="username@example.com"
              v-model="form.email"
            />
            <!--Teléfono -->
            <BaseNumber
              label="Teléfono"
              placeholder="3101234567"
              v-model="form.phone"
            />
            <!-- Fecha de creación. -->
            <BaseRangeDate
              ref="Fecha de creacion"
              label="Fecha de creación"
              :value="form.creation_start && form.creation_end ? [form.creation_start, form.creation_end] : null"
              @notify-dates="setRangeDate($event)"
            />
            <!-- Fecha gestión de solicitud. -->
            <BaseRangeDate
              ref="Fecha de gestión de solicitud"
              label="Fecha de gestión de solicitud"
              :value="form.management_start && form.management_end ? [form.management_start, form.management_end] : null"
              @notify-dates="setRangeDateManagement($event)"
            />
            <!--Tipo de problema -->
            <BaseSelect
              ref="tipo_problema"
              id="tipo_problema"
              label="Tipo de problema"
              :selectOptions="formOptions.optionsTypeProblem"
              v-model="form.type_problem"
              :value="form.type_problem"
              :loading="loading"
            />
            <!--Estado -->
            <BaseSelect
              ref="estado"
              id="estado"
              label="Estado"
              :selectOptions="formOptions.optionsStateTechnicalSupport"
              v-model="form.status_cod"
              :value="form.status_cod"
              :loading="loading"
            />
          </div>

          <div class="w-full flex justify-end self-end gap-4 mt-5 mb-3">
            <a-button
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
              type="danger"
              ghost
              shape="round"
              @click="clearFilters"
            >
              Limpiar
            </a-button>

            <!-- :disabled="disableButton && disabled" -->
            <!-- :loading="(searching = loading)"  -->
            <a-button
              :disabled="searching ? true : false"
              type="primary"
              shape="round"
              @click="submitForm"
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
            >
              <a-icon type="search" v-if="!searching"></a-icon>
              {{ searching ? "BUSCANDO..." : "BUSCAR" }}
            </a-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "../../../../core/utils/constants";

export default {
  props: ["loading", "searching"],
  data() {
    return {
      form: {
        name: "",
        identification_type: "",
        identification_number: "",
        email: "",
        phone: "",
        management_start: "",
        management_end: "",
        type_problem: "",
        status_cod: "",
        creation_end: "",
        creation_start: "",
      },
      showFilters: false, 
    };
  },
  created() {
    this.initializeForm();
  },
  async mounted() {
    const pagination = {};
    this.$emit("getFilterForm", this.form, pagination);
  },
  methods: {
    async submitForm() {
      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", this.form, pagination);
    },
    async clearFilters() {
      this.initializeForm();

      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", this.form, pagination);
    },
    initializeForm() {
      const startDate = moment().subtract(7, "d").format("YYYY-MM-DD");
      const endDate = moment().format("YYYY-MM-DD");
      this.form = {
        name: "",
        identification_type: "",
        identification_number: "",
        email: "",
        phone: "",
        management_start: "",
        management_end: "",
        type_problem: "",
        status_cod: "",
        creation_start: startDate,
        creation_end: endDate,
      };
    },
    setRangeDate(eventValue) {
      this.form.creation_start = eventValue ? eventValue[0] : "";
      this.form.creation_end = eventValue ? eventValue[1] : "";
    },
    setRangeDateManagement(eventValue) {
      this.form.management_start = eventValue ? eventValue[0] : "";
      this.form.management_end = eventValue ? eventValue[1] : "";
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
  },
};
</script>

<style>
#filterSupportForm {
  width: 100%;
}
</style>
